export enum SerieCategory {
  'validated' = 'validated',
  'unvalidated' = 'unvalidated',
  'capacity' = 'capacity',
  'forecast' = 'forecast',
  'loadCurve' = 'loadCurve',
  'fixed' = 'fixed',
  'unfixed' = 'unfixed',
  'average' = 'average',
  'declared' = 'declared',
  'sellOrder' = 'sellOrder',
  'buyOrder' = 'buyOrder',
  'nomination' = 'nomination',
  'carbonAccounting' = 'carbonAccounting',
}
